import React, {useEffect, useRef, useState} from 'react';
import styles from "./Tutorials.module.scss";
import {DataGrid} from "@mui/x-data-grid";
import {PROD_API_URL} from "../../constants/constants";
import {useSelector, useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {PATH_TUTORIAL_ADMINISTRATION} from "../../App";
import Button, {BUTTON_TYPE_SECONDARY} from "../../Components/Button/Button";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import toast from "react-hot-toast";
import {errorToast} from "../../helpers/toastCSS";
import {setTutorialData} from "../../Components/Header/tutorialData";
import moment from "moment";

export const NEW_TUTORIAL_ID = 'newTutorial';

function Tutorials() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminUser = useSelector(state => state.userData.adminUser);

  const [rows, setRows] = useState();

  useEffect(() => {
    const fetchTutorials = async () => {
      fetch(PROD_API_URL + "/tutorials/", {
        "method": "GET",
        "headers": {"content-type": "application/json", "accept": "*"},
      }).then(res => res.json())
        .then((result) => {
          parseResult(result);
          dispatch(setTutorialData(result.data));
        });
    }

    fetchTutorials();
  }, []);

  const parseResult = (result) => {
    const finalResult = [];
    if (result && result.data) {
      result.data.forEach((tutorial) => {
        finalResult.push({
          id: tutorial.id,
          name: tutorial.name,
          type: tutorial.type,
          showInProduction: tutorial.showInProduction ? 'Yes' : 'No',
          description: tutorial.description,
          createdAt: moment.unix(tutorial.createdAt / 1000).format('YYYY-MM-DD , hh:mm A'),
          updatedAt: moment.unix(tutorial.updatedAt / 1000).format('YYYY-MM-DD , hh:mm A'),
        });
      });
    }
    setRows(finalResult);
  }

  const columns = [
    {field: 'name', headerName: 'Name', flex: 1},
    {field: 'type', headerName: 'Type', width: 160},
    {field: 'showInProduction', headerName: 'Production', width: 120},
    {field: 'description', headerName: 'Description', flex: 2},
    {field: 'createdAt', headerName: 'Created At', width: 180},
    {field: 'updatedAt', headerName: 'Updated At', width: 180},
  ];

  const redirectToCreateOrEdit = (id) => {
    navigate(`${PATH_TUTORIAL_ADMINISTRATION}/${id}`);
  }

  return (
    <main id="home" key="home" className={styles.mainTutorialContainer}>
      <div className={styles.tutorialAdminContainer}>
        <div className={styles.tutorialTableContainer}>
          {!rows && <LoadingSpinner local/>}
          {rows &&
            <DataGrid
              rows={rows}
              onCellDoubleClick={(params) => redirectToCreateOrEdit(params.row.id)}
              columns={columns}
            />
          }
        </div>
        <div className={styles.tutorialTableFooter}>
          <Button text="CREATE NEW TUTORIAL" buttonType={BUTTON_TYPE_SECONDARY}
                  onClick={() => redirectToCreateOrEdit(NEW_TUTORIAL_ID)}/>
        </div>
      </div>
    </main>
  );
}

export default Tutorials;